import * as Yup from "yup";

/**
 * Query params for GET `/api/resident-group?...` (search / picker).
 * `location_id` is required; optional `search_term` filters results.
 */
export const searchResidentGroupQuerySchema = Yup.object({
  location_id: Yup.string().trim().required(),
  search_term: Yup.string().trim().nullable().optional(),
  all: Yup.boolean().optional(),
  page: Yup.number().integer().positive().optional(),
});
